import {AiOutlineInstagram} from "react-icons/ai";
import {AiOutlineTwitter} from "react-icons/ai";
import {AiOutlineDribbble} from "react-icons/ai";
import {AiFillGithub} from "react-icons/ai";

const data = [
    {id:1, link: "http://instagram.com", icon: <AiOutlineInstagram/>},
    {id:1, link: "http://twitter.com", icon: <AiOutlineTwitter/>},
    {id:1, link: "http://dribble.com", icon: <AiOutlineDribbble/>},
    {id:1, link: "http://github.com", icon: <AiFillGithub/>}

]

export default data